import { all } from 'redux-saga/effects';

import auth from './auth/sagas';
import slides from './slides/sagas';

export default function* rootSaga() {
  return yield all([auth, slides]);
}
